export default function OurServicesHeader() {
  return (
    <div className="flex flex-col justify-center gap-6 items-center max-w-2xl">
      <div className="inline-flex px-8 py-2 border-2 border-[#464646] text-[#464646] rounded-full font-semibold text-xs lg:text-sm">
        DESCUBRA
      </div>
      <h1 className="text-4xl w-[90%] flex flex-col lg:text-5xl font-extrabold text-center leading-snug gap-2">
        <p className="text-[#003862]">CAIXA Pré-Pagos </p>
        <p className="text-bluecaixa">É benefício todo dia!</p>
      </h1>
      <p className="text-[#525252] w-full text-base font-thin leading-relaxed text-center">
        Encontre as melhores soluções, pensadas para adicionar tecnologia e
        praticidade ao seu dia a dia ou à rotina dos benefícios corporativos na
        sua empresa.
      </p>
    </div>
  );
}
